<template>
  <div class="resume">
    <div class="banner"></div>

    <div :class="this.isMobile.value ? 'profile-mobile' : 'profile'">
      <div class="profile-header">
        <div class="profile-header__title">
          <h2>公开招标公告</h2>
        </div>
      </div>

      <div class="wrap detail-wrap">
        <div class="back-list" @click="cancel"><<返回</div>
        <el-form ref="form" :model="form">
          <div class="detail-line">
            <div class="detail-lable">类型：</div>
            <div class="detail-value">{{getDict(typeOptions,'id','value', form.type)}}</div>
          </div>
          <div class="detail-line">
            <div class="detail-lable">标题：</div>
            <div class="detail-value">{{form.title}}</div>
          </div>
          <div class="detail-line">
            <div class="detail-lable">招标内容：</div>
            <div class="detail-value">{{form.content}}</div>
          </div>
          <div class="detail-line">
            <div class="detail-lable">招标文件：</div>
            <div class="detail-value" v-if="form.applyId"><el-link type='primary' @click="bidFile">点击查看</el-link></div>
          </div>
          <div class="detail-line">
            <div class="detail-lable">招标清单：</div>
            <div class="detail-value" v-if="form.applyId"><el-link type='primary' @click="listing">点击查看</el-link></div>
          </div>
          <div class="detail-line">
            <div class="detail-lable">开标日期：</div>
            <div class="detail-value">{{form.openBid}}</div>
          </div>
          <div class="detail-line">
            <div class="detail-lable">发布日期：</div>
            <div class="detail-value">{{form.publicTime}}</div>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancel">返 回</el-button>
        </div>
    </div>
  </div>
  </div>
</template>
<script>
import { listPublicBid, getPublicBid, delPublicBid, addPublicBid, updatePublicBid } from "@/api/purchase/publicBid";
import { listBidFileApply, getBidFileApply } from "@/api/purchase/bidFileApply";
import {getDicts} from "@/utils/data";
import { getToken } from "@/utils/auth";
import { getUserInfo, register } from "@/api/user";
import { listPurchaseMaterialType } from "@/api/purchase/purchaseMaterialType";
import { HOME_URL } from "@/constants/url";
let positionY = 0;

export default {
  name: "publicBid",
  data() {
    return {
      currentPage: 1,
      jobCategories: [],
      jobCities: [],
      location_code_list: [],
      cityList: [],
      cities: [],
      results: [],
      searchBarFixedTop: false,
      loading: false,
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态字典
      statusOptions: [],
      // 表单参数
      form: {},
      upload: {
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: "Bearer " + getToken() },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/api/purchase/file/upload",
        // 上传的文件列表
        fileList: [],
      },
      bidFileList: [],
      disabled: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        // pageNum: 1,
        // pageSize: 10,
      },
      // 显示搜索条件
      showSearch: true,
      typeOptions: [],
    };
  },

  created() {
    listPurchaseMaterialType({fId: "0"}).then(response => {
      this.typeOptions = response.rows;
    });
    this.handleUpdate(this.$route.query.id);
  },
  mounted() {
  },
  computed: {
    queryFilter() {
      return {
        // postName: this.searchKeyword,
      };
    },
    clearable() {
      return (
        this.job_category_id_list.length !== 0 ||
        this.location_code_list.length !== 0
      );
    }
  },
  watch: {

  },
  methods: {
    bidFile() {
      getBidFileApply(this.form.applyId).then(response => {
        let apply = response.data;
        if(apply.contractId && !apply.wpsFileId){
          location.href = HOME_URL.PROD + "/purchase/purchaseDocumentForPublicView?id=" + apply.contractId;
        }else if(apply.wpsFileId) {
          location.href = HOME_URL.PROD + "/purchase/bidFileWPSView?wpsAssertUrl=" + apply.wpsAssertUrl + "&applyId=" + this.form.applyId;
        }
      });
    },
    listing() {
      location.href = HOME_URL.PROD + "/purchase/listingDetailForPublicView?id=" + this.form.applyId;
    },
    typeFormat(row, column) {
      let list = this.typeOptions.filter(i=>i.id == row.type);
      if(list.length > 0){
        return list[0].value;
      }
      return '';
    },
    handleQuery() {
      this.getList();
    },
    getList() {
      this.loading = true;
      listPublicBid(this.queryParams).then(response => {
        this.results = response;
        this.total = response.total;
        this.loading = false;
      });
    },
    fetchList() {
      this.loading = true;

      return this.request
        .get("/api/purchase/publicBid/list", this.queryFilter)
        .then(response => {
          this.results = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 状态字典翻译
    statusFormat(row, column) {
      let list = this.statusOptions.filter(i=>i.dictValue == row.status);
      if(list.length > 0){
        return list[0].dictLabel;
      }
      return '';
    },
    // 取消按钮
    cancel() {
      // this.open = false;
      this.$router.back();
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        requireUnit: null,
        content: null,
        remark: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        version: null,
        uuid: null,
        postId: null,
        status: null,
        batchNumber: null,
        deadline: null,
        startTime: null,
        contacts: null,
        contactsPhone: null
      };
      this.bidFileList = [];
    },
    /** 修改按钮操作 */
    handleUpdate(id) {
      this.reset();
      getPublicBid(id).then(response => {
        this.reset();
        this.form = response.data;
        this.form.publicTime = this.form.updateTime ? this.form.updateTime.split(/\s+/)[0] : this.form.createTime.split(/\s+/)[0];
        this.bidFileList = response.data.bidFileList;
      });
    },

    // 文件超出个数限制时的钩子函数
    fileLimitCallback(files, fileList) {
      this.$message.warning(`当前限制最多选择 10 个文件`);
    },
    onBeforeUpload(file) {
      const isLt200M = file.size / 1024 / 1024 < 20;
      if (!isLt200M) {
        this.$message.error("上传文件大小不能超过 20M!");
        return false;
      }
      return true;
    },
    handleFileChange(file, fileList) {
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件超出个数限制时的钩子函数
    importExcelLimitCallbck() {
      this.$message.warning(`当前限制最多导入 1 个文件`);
    },
    // 处理附件上传
    uploadFileSuccess(response, file, fileList) {
      this.upload.isUploading = false;
      if (response != null && response.code == 200) {
        let files = [];
        fileList.forEach(function (val, index) {
          if(val.response){
            files.push(val.response.data);
          }else {
            files.push(val);
          }

        });
        this.bidFileList = files;
        this.$message.success("上传成功");
      } else {
        this.$message.error(response.msg);
      }
    },
    // 文件上传失败处理
    handleFileError(err, file, fileList) {
      this.upload.isUploading = false;
      this.$message.error("文件上传失败");
    },
    // 处理附件移除
    removeFileSuccess(file, fileList) {
      this.bidFileList = fileList;
    },
    // 文件提交处理
    submitUpload() {
      this.$refs.fileUpload.submit();
    },
    // 文件预览
    handlePreview(file) {
      window.open(file.url);
    },
    getDict(dictArr, key, label, val){
      for (const item of dictArr) {
        if(item[key] == val){
          return item[label]
        }
      }
      return ""
    }
  }
};
</script>
<style lang="less" scoped>
.banner {
  background-image: url("//sf1-ttcdn-tos.pstatp.com/obj/ttfe/ATSX/my_resume_banner_1577084307030.jpg");
  background-size: 100% 100%;
  height: 300px;
  background-repeat: no-repeat;
}

.profile {
  width: 900px;
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;

    .resumeViewSection {
      min-height: 200px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}

.profile-mobile {
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;

    .resumeViewSection {
      min-height: 200px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}

.wrap{
  width: 900px;
  margin: 0 auto;
  /*background-color: red;*/
}
@media(max-width:960px){
  .wrap{
    width: 100%;
    margin: 0 auto;
  }
}
.detail-wrap{
  /*padding: 20px 50px 50px 50px;*/
  /*font-size: 18px;*/
  /*!*box-shadow: 3px 5px 10px 5px #ccc;*!*/
  /*margin-top: 30px;*/
  /*background-color: #fff;*/


  margin-top: 30px;
  background: #fff;
  box-shadow: 0px 9px 20px 0px #c2c1c180;
  border-radius: 4px;
  padding: 30px;
  padding-top: 0;
}
@media(max-width:960px){
  .detail-wrap{
    padding: 20px;
    padding-top: 0;
  }
}
.back-list{
  height: 100px;
  line-height: 100px;
  color: blue;
  cursor: pointer;
}
.detail-line{
  display: flex;
  margin-bottom: 30px;
  .detail-lable{
    width: 150px;
    text-align: right;
    margin-right: 30px;
    color: #333;
  }
  @media(max-width:960px){
    .detail-lable{
      width: 120px;
    }
  }
  .detail-value{
    flex: 1;
    color: #515151;
  }
}
@media(max-width:960px){
  .banner{
    height: 210px !important;
  }
  .profile-header{
    margin-left: 20px !important;
  }
  .back-list{
    height: 60px;
    line-height: 60px;
  }
}
</style>
